import React from "react";
import "../styles/Education.css";

// Import logos (ensure these exist in your images folder)
import ubLogo from "../images/University_at_Buffalo.png";
import puLogo from "../images/Panjab_University_Chandigarh.png";

const Education = () => {
  const educationData = [
    {
      university: "University at Buffalo",
      degree: "MS in Computer Science & Engineering",
      duration: "2023 – 2025",
      location: "Buffalo, NY",
      website:
        "https://engineering.buffalo.edu/computer-science-engineering/graduate/degrees-and-programs/ms-in-computer-science-and-engineering.html",
      logo: ubLogo,
    },
    {
      university: "Panjab University",
      degree: "Master of Computer Applications (M.C.A)",
      duration: "2018 – 2021",
      location: "Chandigarh, India",
      website: "https://dcsa.puchd.ac.in/",
      logo: puLogo,
    },
  ];

  return (
    <div className="education-container">
      <h2>Education</h2>
      <div className="education-list">
        {educationData.map((edu, index) => (
          <div key={index} className="education-item">
            <img src={edu.logo} alt={edu.university} className="edu-logo" />
            <div className="edu-content">
              <h3>{edu.university}</h3>
              <p>{edu.degree}</p>
              <p>{edu.duration}</p>
              <p>{edu.location}</p>
              <a href={edu.website} target="_blank" rel="noopener noreferrer">
                Visit Website
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
